<script setup lang="ts">
import { ref, watchEffect } from "vue";
import DOMPurify from "dompurify";

const props = defineProps({
  html: {
    type: String,
    required: true,
  },
  tag: {
    type: String,
    default: "div",
  },
});
const cleanHtml = ref<string | null>(props.html);
const SSR = import.meta.env.SSR;

watchEffect(() => {
  if (DOMPurify.isSupported) {
    cleanHtml.value = DOMPurify.sanitize(props.html);
  }
});
</script>
<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <!-- Por alguna razón en SSR no se renderiza compontent is:tag, se recurre a hacerlo manualmente. Agregar los lementos que se requieran. -->
  <span v-if="SSR && tag == 'span'" v-html="cleanHtml"></span>
  <div v-else-if="SSR && tag == 'div'" v-html="cleanHtml"></div>
  <p v-else-if="SSR && tag == 'p'" v-html="cleanHtml"></p>
  <component :is="tag" v-else v-html="cleanHtml" />
</template>
